import { useParams } from "@/components/hooks/use-params";
import { usePathname } from "@/components/hooks/use-pathname";
import { useSafeAreaInsets } from "@/components/hooks/use-safe-area-insets";
import { useWindowDimensions } from "@/components/hooks/use-window-dimension";
import { ListHeading } from "@/components/shared/list-header";
import { useRoute } from "@/components/shared/router";
import { Card, View } from "@/components/ui";
import { IconButton } from "@/components/ui/icon-button";
import { AccountGiftCardHistory } from "@/containers/profile/account-gift-card/account-gift-card-history-component";
import { GiftCardHistoryFilter } from "@/containers/profile/account-gift-card/account-gift-card-history-component/gift-card-history-filter";
import { normalizeGiftCardTab } from "@/containers/profile/account-gift-card/account-gift-card-history-component/lib";

import { ShareGiftCardModalProvider } from "../share-gift-card-modal";

export const AccountGiftCardHistoryPage = () => {
  const { top } = useSafeAreaInsets();
  const { isMobile } = useWindowDimensions();
  const { pull } = useRoute();
  const { tab } = useParams<{ tab?: string | string[] }>();
  const activeTab = Array.isArray(tab) ? tab[0] : tab;
  const basePath = usePathname() || "/profile/gift-card/history";
  const normalizedTab = normalizeGiftCardTab(activeTab);

  return (
    <ShareGiftCardModalProvider>
      <View style={{ paddingTop: top }}>
        <View className="flex flex-col gap-0 p-4">
          <View className="flex flex-row items-center justify-between py-2">
            <View className="flex flex-row items-center gap-4">
              <IconButton
                variant={isMobile ? "ghost" : "secondary"}
                color="foreground"
                iconName="arrowLeft"
                rounded="full"
                onClick={() => pull()}
              />
              <ListHeading title="Gift Card History" />
            </View>
          </View>
          <GiftCardHistoryFilter basePath={basePath} activeTab={normalizedTab} />
          <Card className="mt-4">
            <AccountGiftCardHistory filter={{ tab: normalizedTab }} />
          </Card>
        </View>
      </View>
    </ShareGiftCardModalProvider>
  );
};
